import MotionController from "../lib/motion_controller"
import { gsap, FINE_POINTER } from "../lib/motion"

// Cursor-reactive accent glow plus a gentle 3D tilt on a product mockup.
// Only for fine pointers with motion allowed; touch devices get the static glow.
//   targets: glow (follows the pointer), tilt (rotates toward it)
export default class extends MotionController {
  static targets = [ "glow", "tilt" ]
  static values = { tilt: { type: Number, default: 3 } }

  animate({ desktop }) {
    if (!desktop || !window.matchMedia(FINE_POINTER).matches) return

    const glowX = this.hasGlowTarget && gsap.quickTo(this.glowTarget, "x", { duration: 1.2, ease: "power3.out" })
    const glowY = this.hasGlowTarget && gsap.quickTo(this.glowTarget, "y", { duration: 1.2, ease: "power3.out" })
    const rotX = this.hasTiltTarget && gsap.quickTo(this.tiltTarget, "rotationX", { duration: 1, ease: "power3.out" })
    const rotY = this.hasTiltTarget && gsap.quickTo(this.tiltTarget, "rotationY", { duration: 1, ease: "power3.out" })

    let bounds = null
    const measure = () => { bounds = this.element.getBoundingClientRect() }

    const move = (event) => {
      if (!bounds) measure()
      const px = (event.clientX - bounds.left) / bounds.width
      const py = (event.clientY - bounds.top) / bounds.height
      if (glowX) {
        glowX((px - 0.5) * bounds.width)
        glowY((py - 0.5) * bounds.height)
      }
      if (rotX) {
        rotY((px - 0.5) * this.tiltValue * 2)
        rotX((0.5 - py) * this.tiltValue * 2)
      }
    }

    const leave = () => {
      bounds = null
      if (glowX) { glowX(0); glowY(0) }
      if (rotX) { rotX(0); rotY(0) }
    }

    const invalidate = () => { bounds = null }

    this.element.addEventListener("pointerenter", measure)
    this.element.addEventListener("pointermove", move)
    this.element.addEventListener("pointerleave", leave)
    window.addEventListener("scroll", invalidate, { passive: true })
    window.addEventListener("resize", invalidate)

    return () => {
      this.element.removeEventListener("pointerenter", measure)
      this.element.removeEventListener("pointermove", move)
      this.element.removeEventListener("pointerleave", leave)
      window.removeEventListener("scroll", invalidate)
      window.removeEventListener("resize", invalidate)
    }
  }
}
